import { Link } from 'react-router-dom';
import { Instagram, Facebook, Mail } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="bg-[#354F52] text-[#FAF9F6]">
      <div className="container-custom px-6 md:px-12 lg:px-24 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="md:col-span-2">
            <h3 className="font-serif text-2xl mb-4">
              Whispering Wristwear
            </h3>
            <p className="text-[#CAD2C5] leading-relaxed max-w-sm mb-6">
              Handcrafted Morse code bracelets that carry your secret messages. 
              Each piece is made with intention and love.
            </p>
            <div className="flex items-center gap-3" data-testid="footer-maker">
              <img
                src="/images/lindy-in-studio.jpg"
                alt="Lindy, founder of Whispering Wristwear"
                className="w-12 h-12 rounded-full object-cover ring-1 ring-[#D4AF37]/40"
                style={{ objectPosition: '50% 30%' }}
              />
              <div className="text-sm">
                <p className="text-[#FAF9F6] font-serif italic">Made by Lindy</p>
                <p className="text-[#84A98C] text-xs tracking-widest uppercase">Paphos · Cyprus</p>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-caption text-[#84A98C] mb-4">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <Link 
                  to="/products" 
                  className="text-[#CAD2C5] hover:text-[#D4AF37] transition-colors"
                  data-testid="footer-shop"
                >
                  Shop All
                </Link>
              </li>
              <li>
                <Link 
                  to="/custom" 
                  className="text-[#CAD2C5] hover:text-[#D4AF37] transition-colors"
                  data-testid="footer-custom"
                >
                  Custom Orders
                </Link>
              </li>
              <li>
                <Link 
                  to="/blog" 
                  className="text-[#CAD2C5] hover:text-[#D4AF37] transition-colors"
                  data-testid="footer-blog"
                >
                  Blog
                </Link>
              </li>
              <li>
                <Link
                  to="/gallery"
                  className="text-[#CAD2C5] hover:text-[#D4AF37] transition-colors"
                  data-testid="footer-gallery"
                >
                  Gallery
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-[#CAD2C5] hover:text-[#D4AF37] transition-colors"
                  data-testid="footer-about"
                >
                  About Lindy
                </Link>
              </li>
            </ul>
          </div>

          {/* Policies */}
          <div>
            <h4 className="text-caption text-[#84A98C] mb-4">Information</h4>
            <ul className="space-y-3">
              <li>
                <Link 
                  to="/shipping"
                  className="text-[#CAD2C5] hover:text-[#D4AF37] transition-colors"
                  data-testid="footer-shipping"
                >
                  Shipping Policy
                </Link>
              </li>
              <li>
                <Link
                  to="/sizing-guide"
                  className="text-[#CAD2C5] hover:text-[#D4AF37] transition-colors"
                  data-testid="footer-sizing-guide"
                >
                  Sizing Guide
                </Link>
              </li>
              <li>
                <Link 
                  to="/returns"
                  className="text-[#CAD2C5] hover:text-[#D4AF37] transition-colors"
                  data-testid="footer-returns"
                >
                  Returns & Exchanges
                </Link>
              </li>
              <li>
                <Link 
                  to="/contact"
                  className="text-[#CAD2C5] hover:text-[#D4AF37] transition-colors"
                  data-testid="footer-contact"
                >
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-16 pt-8 border-t border-[#52796F]/30 flex flex-col md:flex-row justify-between items-center gap-6">
          <p className="text-[#84A98C] text-sm">
            © {new Date().getFullYear()} Whispering Wristwear. All rights reserved.
          </p>

          {/* Social Links */}
          <div className="flex items-center gap-4">
            <a 
              href="#" 
              className="p-2 hover:bg-[#52796F]/30 rounded-full transition-colors"
              aria-label="Instagram"
              data-testid="footer-instagram"
            >
              <Instagram className="w-5 h-5 text-[#CAD2C5]" strokeWidth={1.5} />
            </a>
            <a 
              href="#" 
              className="p-2 hover:bg-[#52796F]/30 rounded-full transition-colors"
              aria-label="Facebook"
              data-testid="footer-facebook"
            >
              <Facebook className="w-5 h-5 text-[#CAD2C5]" strokeWidth={1.5} />
            </a>
            <a 
              href="mailto:hello@whisperingwristwear.com" 
              className="p-2 hover:bg-[#52796F]/30 rounded-full transition-colors"
              aria-label="Email"
              data-testid="footer-email"
            >
              <Mail className="w-5 h-5 text-[#CAD2C5]" strokeWidth={1.5} />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
